import React from "react";
import { WarningOctagon, CheckCircle } from "@phosphor-icons/react";

export function PanicTab({ panics, onResolve }) {
  return (
    <div className="fade-in">
      <h1 className="font-display text-3xl font-black mb-4">Alertas de pánico</h1>
      <div className="space-y-3" data-testid="admin-panic-list">
        {panics.length === 0 && <div className="card text-center text-slate-500 py-8">Sin alertas registradas</div>}
        {panics.map((a) => (
          <div key={a.id} className={`card flex items-center justify-between ${a.status === "active" ? "border-2 border-red-500" : "opacity-70"}`} data-testid={`panic-alert-${a.id}`}>
            <div className="flex items-center gap-3 min-w-0">
              <div className={`w-11 h-11 rounded-xl flex items-center justify-center shrink-0 ${a.status === "active" ? "bg-red-100 text-red-600" : "bg-slate-100 text-slate-400"}`}>
                <WarningOctagon size={22} weight="fill" />
              </div>
              <div className="min-w-0">
                <div className="font-bold">{a.passenger_name} {a.passenger_phone ? <span className="text-xs text-slate-500 font-normal">· {a.passenger_phone}</span> : null}</div>
                <div className="text-xs text-slate-500 font-mono">{a.lat?.toFixed(4)}, {a.lng?.toFixed(4)} · {new Date(a.created_at).toLocaleString()}</div>
                <div className="text-xs text-slate-500">Contactos avisados: {(a.contacts_notified || []).join(", ") || "ninguno"}</div>
              </div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <a href={`https://www.openstreetmap.org/?mlat=${a.lat}&mlon=${a.lng}#map=17/${a.lat}/${a.lng}`} target="_blank" rel="noreferrer" className="btn-ghost text-sm">Ver mapa</a>
              {a.status === "active" ? (
                <button onClick={() => onResolve(a.id)} className="btn-primary text-sm" data-testid={`resolve-panic-${a.id}`}>
                  <CheckCircle size={16} className="inline mr-1" weight="fill" /> Resolver
                </button>
              ) : (
                <span className="pill pill-online">Resuelta</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
